import Image from 'next/image';
import React from 'react';

import { V1Amount } from '@/api/clients/ohip';
import { Box, Flex } from '@/box';
import { CurrencyPreview } from '@/currency-preview';
import { useTranslation } from '@/i18n';
import { useTheme } from '@/ui/theme';
import { BodySmall } from '@/ui/typography';

export const MembershipAlert = (props: { amountSaved: V1Amount }) => {
  const { t } = useTranslation('bookingMembership');
  const {
    componentProperties: { staySummary, sidebarCards },
  } = useTheme();

  return (
    <Box
      css={{
        padding: '10px 24px 10px 12px',
        backgroundColor: '#FFF',
        marginTop: '12px',
        border: '1px solid #143C21',
        borderRadius:
          staySummary?.borderRadius ?? sidebarCards?.secondary?.borderRadius,
        boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.25)',
        color: '#143C21',
      }}
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex gap="12px" alignItems="center">
          <Image src="/icons/price-tag.svg" width={29} height={29} alt="" />
          <BodySmall uppercase css={{ color: 'inherit', fontWeight: 'bold' }}>
            {t('card.membershipSaving')}
          </BodySmall>
        </Flex>
        <BodySmall css={{ color: 'inherit', fontWeight: 'bold' }}>
          <CurrencyPreview amount={props.amountSaved} />
        </BodySmall>
      </Flex>
    </Box>
  );
};
